var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"pg-checkbox-group"},_vm._l((_vm.sources),function(source){return _c(_setup.PgCheckbox,{key:source.code,style:(_vm.CBstyle),attrs:{"value":_setup.mapValue[source.code],"text":source.name},on:{"change":(v, e) => _setup.change(v, source, e)}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }